export const mcStatus = {
  /**
   * Checks if the process.env.NODE_ENV is currently 'development'
   * @returns true if it is, otherwise false
   */
  isInDevMode(): boolean {
    let devMode:boolean = process.env.NODE_ENV === 'development';
    return devMode;
  }
}
